import { trackProductEvent, type AnalyticsProperties } from '@/lib/analytics';

export type ClientOnboardingSpecificStepCompletedEventName =
  | 'Client Onboarding Step 2 Completed'
  | 'Client Onboarding Step 3 Completed';

export const trackClientOnboardingStepCompleted = (
  properties: AnalyticsProperties,
  specificEventName?: ClientOnboardingSpecificStepCompletedEventName | null
) => {
  trackProductEvent('Client Onboarding Step Completed', properties);
  if (specificEventName) {
    trackProductEvent(specificEventName, properties);
  }
};

export const trackClientOnboardingFollowUpSelected = (properties: AnalyticsProperties) => {
  trackProductEvent('Client Onboarding Follow Up Selected', properties);
};

export const trackClientOnboardingStepViewed = (properties: AnalyticsProperties) => {
  trackProductEvent('Client Onboarding Step Viewed', properties);
};

export const trackClientOnboardingBackClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('Client Onboarding Back Clicked', properties);
};

export const trackClientOnboardingExited = (properties: AnalyticsProperties) => {
  trackProductEvent('Client Onboarding Exited', properties);
};

export const trackClientOnboardingCompleted = (properties: AnalyticsProperties) => {
  trackProductEvent('Client Onboarding Completed', properties);
};
